export const mediosMap = {
  debit_card: "TARJETA DÉBITO",
  credit_card: "TARJETA CRÉDITO",
  prepaid_card: "TARJETA PREPAGA",
  account_money: "DINERO EN CUENTA MERCADO PAGO",
  ticket: "PAGO EN EFECTIVO",
  bank_transfer: "TRANSFERENCIA BANCARIA"
};

export const tarjetasMap = {
  visa: "VISA",
  master: "MASTERCARD",
  amex: "AMERICAN EXPRESS",
  cabal: "CABAL",
  naranja: "NARANJA",
  tarshop: "TARSHOP",
  mercadopago: "MERCADO PAGO",
  rapipago: "RAPIPAGO",
  pagofacil: "PAGO FÁCIL",
  debvisa: "VISA",
  debmaster: "MASTERCARD",
  debamex: "AMERICAN EXPRESS",
  bbva: "BBVA",
  brubank: "BRUBANK"
};
